// import config from 'config';
import axios from "axios";

export const userService = {
    login,
    logout,
};

function login(username, password) {
    const requestOptions = {
      method: 'POST',
      url: '/api/token2/',
      headers: { 'Content-Type': 'application/json' },
      data: {
        username: username,
        password: password
      }
    };

    return axios(requestOptions)
        .then(handleResponse);
}

function logout() {
    // remove user from local storage to log user out
    localStorage.removeItem('user');
}


function handleResponse(response) {
  const data = response.data

  if (response.status != "200") {
    const error = (data && data.message) || response.statusText;
    return Promise.reject(error);
  }
  // login successful if there's a jwt token in the response
  if (data.access) {
    // store user details and jwt token in local storage to keep user logged in between page refreshes
    localStorage.setItem('user', JSON.stringify(data));
  }

  return data;
}
